module.exports = __webpack_public_path__ + "img/serve2.d76ce68d.jpg";